export default __webpack_public_path__ + "assets/catalonia-flag.png";